export enum VaultActions {
	RESET_VAULT = "RESET_VAULT",
	UPDATE_VAULT = "UPDATE_VAULT"
}
